const collectionDetail = {
  subtitle: "Discover groups of products curated by {{- storeName}}.",
  collectionsMenuLabel: "Collections",
  errorLoadingCollection: "Error loading collection data",
} as const;

export { collectionDetail };
